import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Document } from '../_models/document';
import { DocumentoService } from '../_services/documents.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  privacyPolicyDocument?: string;

  constructor(
    private _documentoService: DocumentoService,
  ) { }

  ngOnInit(): void {
    this.getPrivacyPolicyDocument();
  }

  private getPrivacyPolicyDocument(): void {
    this._documentoService.getDocument(environment.POLICY_DOCUMENT_CODE)
      .subscribe({
        next: (response: Document[]): void => {
          this.privacyPolicyDocument = response[0].url;
        },
      });
  }

}
